import { argumentsToString } from '../utilities';
import { omitRepeatedWarnings } from '../settings';
export var release = true;
export var debugable = true;
var Debug = /** @class */ (function () {
    function Debug() {
    }
    Debug.release = release;
    Debug.assert = assert;
    Debug.error = error;
    Debug.assertUnreachable = assertUnreachable;
    Debug.assertNotImplemented = assertNotImplemented;
    Debug.warning = warning;
    Debug.notImplemented = notImplemented;
    Debug.dummyConstructor = dummyConstructor;
    Debug.warnCounts = warnCounts;
    Debug.abstractMethod = abstractMethod;
    Debug.somewhatImplemented = somewhatImplemented;
    Debug.unexpected = unexpected;
    Debug.unexpectedCase = unexpectedCase;
    return Debug;
}());
export { Debug };
export function notImplemented(message) {
    warning('AVM1 not implemented: ' + message);
}
export function somewhatImplemented(message) {
    warning('AVM1 somewhatImplemented: ' + message);
}
export function error(message) {
    console.error(message);
    throw new Error(message);
}
export function assert(condition, message) {
    if (message === void 0) { message = 'assertion failed'; }
    if (condition === '') { // avoid inadvertent false positive
        condition = true;
    }
    if (!condition) {
        if (typeof console !== 'undefined' && 'assert' in console) {
            console.assert(false, message);
            throw new Error(message);
        }
        else {
            error(message.toString());
        }
    }
}
export function assertUnreachable(msg) {
    var location = new Error().stack.split('\n')[1];
    throw new Error('Reached unreachable location ' + location + msg);
}
export function assertNotImplemented(condition, message) {
    if (!condition) {
        error('notImplemented: ' + message);
    }
}
var _warnedCounts = Object.create(null);
export function warning(message, arg1, arg2 /*...messages: any[]*/) {
    if (release) {
        return;
    }
    var key = argumentsToString(arguments);
    if (_warnedCounts[key]) {
        _warnedCounts[key]++;
        if (omitRepeatedWarnings.value) {
            return;
        }
    }
    _warnedCounts[key] = 1;
    console.warn.apply(console, arguments);
}
export function warnCounts() {
    var list = [];
    for (var key in _warnedCounts) {
        list.push({ key: key, count: _warnedCounts[key] });
    }
    list.sort(function (entry, prev) { return prev.count - entry.count; });
    return list.reduce(function (result, entry) { return (result += '\n' + entry.count + '\t' + entry.key); }, '');
}
export function dummyConstructor(message) {
    release || assert(false, 'Dummy Constructor: ' + message);
}
export function abstractMethod(message) {
    release || assert(false, 'Abstract Method ' + message);
}
export function unexpected(message) {
    assert(false, 'Unexpected: ' + message);
}
export function unexpectedCase(message) {
    assert(false, 'Unexpected Case: ' + message);
}
export function registerDebugMethod(func, methodInfo) {
    if (!debugable) {
        return;
    }
    var name = methodInfo.name;
    delete methodInfo.name;
    if (!methodInfo || !name) {
        throw new Error('Method name should not be empty');
    }
    var api = window._AWAY_DEBUG_ = (window._AWAY_DEBUG_ || {});
    if (api.hasOwnProperty(name)) {
        console.warn("Overrides existed debug method definition: " + name);
    }
    Object.assign(func, methodInfo);
    api[name] = func;
}
